var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-picker',_vm._g(_vm._b({staticClass:"vg-picker",scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._t("title")]},proxy:true}],null,true)},'van-picker',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }